// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

const Theme = (colors) => {
  const { blue, red, gold, cyan, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    // primary: {
    //   lightest: '#F4FFFF',
    //   lighter: '#e8faff',
    //   100: '#DCF5FC',
    //   200: '#8BE2FC',
    //   light: '#3352A2',
    //   400: blue[4],
    //   main: '#011140',
    //   dark: '#0c142c',
    //   700: blue[7],
    //   darker: blue[8],
    //   900: blue[9],
    //   contrastText
    // },
    primary: {
      lighter: '#E0F2F1',
      100: '#B2DFDB',
      200: '#80CBC4',
      light: '#4DB6AC',
      400: '#26A69A',
      500: '#009688',
      main: '#009688',
      600: '#00897B',
      700: '#00796B',
      dark: '#00695C',
      900: '#004D40',
      A100: '#A7FFEB',
      darker: '#64FFDA',
      A400: '#1DE9B6',
      A700: '#00BFA5',
      contrastText: 'A7FFEB'
    },

    tertiary: {
      lighter: '#FFF3E0',
      100: '#FFE0B2',
      200: '#FFCC80',
      light: '#FFB74D',
      400: '#FFA726',
      500: '#FF9800',
      main: '#E8A200',
      600: '#FB8C00',
      700: '#F57C00',
      dark: '#EF6C00',
      900: '#E65100',
      A100: '#FFD180',
      darker: '#FFAB40',
      A400: '#FF9100',
      A700: '#FF6D00'
    },

    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: '#fff0f0',
      light: red[1],
      main: red[5],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText
    },
    success: {
      lighter: green[0],
      100: green[1],
      200: green[2],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
};

export default Theme;
